import React from 'react';
import { Logo } from './Logo';
import './LoadingScreen.css';

interface LoadingScreenProps {
  message?: string;
  isVisible: boolean;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "Loading...", 
  isVisible 
}) => {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="logo-container">
          <div className="logo-wrapper">
            <Logo size="xlarge" variant="loading" />
            <div className="loading-ring">
              <div className="ring-segment segment-1"></div>
              <div className="ring-segment segment-2"></div>
              <div className="ring-segment segment-3"></div>
              <div className="ring-segment segment-4"></div>
            </div>
          </div>
        </div>
        
        <div className="loading-content">
          <h2 className="company-name">Affordable Connects</h2>
          <p className="loading-message">{message}</p>
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
};